import React, { memo } from "react";
import PropTypes from "prop-types";
import { CardBody, CardRoot, CardTitle } from "./elements";

export const BettoCard = memo(({ title, children, className, ...rest }) => (
	<CardRoot className={className} {...rest}>
		{title ? <CardTitle>{title}</CardTitle> : null}
		<CardBody>{children}</CardBody>
	</CardRoot>
));

BettoCard.displayName = "BettoCard";

BettoCard.propTypes = {
	title: PropTypes.node,
	children: PropTypes.node,
	className: PropTypes.string,
};
